<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('sports')"></TitlePage>

    <v-layout wrap>

      <v-flex md12 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name"></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4 float-right">
        <v-switch v-model="item.status" inset :label="$t('status')"></v-switch>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import icons from "@/assets/icons";
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "EditCancellationReason",
  components: {TitlePage},
  data() {
    return {
      icons,
      item: {
        name: '',
        status: false,
      },
      check: true,
      errors:{
        name: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ]
      }
    };
  },
  async created(){
    this.setLoading(true);
    let fetchItem = await this.editItem(this.$route.params)

    this.item.name = fetchItem.result.name;
    this.item.status = fetchItem.result.status;

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'cancellationReason/edit',
      'updateItem':'cancellationReason/update',
    }),

    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

    },

    async resetError(){
      this.errors = {
        name: '',
        icon: '',
      }
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>